import { STATUS } from "@/constant/statusConstants";

export const getBlogCategoryInitialValues = (localeCodes, showData) => ({
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
  status: showData?.data?.status || STATUS.INACTIVE,
  icon: null,
  icon_active: null,
});
